import React from 'react';
import { arrayHasItems } from '../helpers/common';

const getBoxStats = (products) => {
  const boxes = products.flatMap(product => product.boxes);
  // const totalQuantity = boxes.reduce((sum, box) => sum + box?.quantity, 0);
  const totalQuantity = boxes.reduce((sum, box) => sum + (box?.shippedQuantity || 0), 0);
  const receivedQuantity = boxes.reduce((sum, box) => sum + (box?.receivedQuantity || 0), 0);
  const percentage = totalQuantity > 0 ? (receivedQuantity / totalQuantity) * 100 : 0;
  return { totalQuantity, receivedQuantity, percentage };
};

const getContainersStats = (containers) => {
  const boxes = containers.flatMap(product => product.items);
  // const totalQuantity = boxes.reduce((sum, container) => sum + container?.quantity, 0);
  const totalQuantity = boxes.reduce((sum, container) => sum + (container?.shippedQuantity || 0), 0);
  const receivedQuantity = boxes.reduce((sum, container) => sum + (container?.receivedQuantity || 0), 0);
  const percentage = totalQuantity > 0 ? (receivedQuantity / totalQuantity) * 100 : 0;
  return { totalQuantity, receivedQuantity, percentage };
};

const ReceivedQtyBarGraph = ({ products, containers, testId }) => {

  let totalQuantity = 0;
  let receivedQuantity = 0;
  let percentage = 0;
  if (arrayHasItems(containers)) {
    const containersData = getContainersStats(containers || []);
    totalQuantity = containersData.totalQuantity;
    receivedQuantity = containersData.receivedQuantity;
    percentage = containersData.percentage;
  } else {
    const boxesData = getBoxStats(products || []);
    totalQuantity = boxesData.totalQuantity;
    receivedQuantity = boxesData.receivedQuantity;
    percentage = boxesData.percentage;
  }

  const quantityFilledPartly = receivedQuantity > 0 && receivedQuantity < totalQuantity;
  const quantityFilledZero = receivedQuantity === 0;
  const quantityFilledAll = receivedQuantity >= totalQuantity;

  const getQuantityBarElements = () => {
    if (quantityFilledPartly) {
      return {
        label: `${receivedQuantity}/${totalQuantity} received`,
        received: receivedQuantity,
        total: totalQuantity,
        labelColor: 'text-primary',
        block: (
          <div
            className="h-full rounded-full bg-gray-500"
            data-testid={testId ? `percentage-${testId}` : undefined}
            style={{ width: `${percentage}%` }}
          />
        )
      }
    }
    if (quantityFilledZero) {
      return {
        label: `0/${totalQuantity} received`,
        received: 0,
        total: totalQuantity,
        labelColor: 'text-gray-600',
        block: null
      }
    }
    if (quantityFilledAll) {
      return {
        label: `All ${totalQuantity} units received`,
        received: totalQuantity,
        total: totalQuantity,
        labelColor: 'text-white',
        block: (
          <div
            className="h-full rounded-full bg-gray-900"
            data-testid={testId ? `percentage-${testId}` : undefined}
            style={{ width: '100%' }}
          />
        )
      }
    }
    return null
  }
  
  const renderData = getQuantityBarElements();

  return (
    <div className="flex items-center gap-2" data-testid={testId}>
      <div className="relative h-2 w-36 overflow-hidden rounded-full bg-gray-200">
        {renderData?.block}
      </div>
      <span className="text-[13px] tabular-nums">
        <b>{renderData?.received}</b>
        <span className="text-gray-500"> / {renderData?.total}</span>
      </span>
    </div>
  );
};

export default ReceivedQtyBarGraph;